module.exports = __webpack_public_path__ + "media/images/flags/tn-878a7338671d0d0af0ae6eac5679fd87.svg";